// import React from "react";

// const SuonaConNoi = () => {
//   return (
//     <div className="pb-24 flex flex-col items-center z-10 bg-gradient-to-r from-white to-amber-50">
//       <p className="text-red-600 font-extrabold xs:text-2xl md:text-3xl ">
//         SUONA CON NOI
//       </p>
//       <div className="flex flex-col w-2/3 items-center xs:text-base md:text-2xl">
//         <p className="mt-6">Vieni a suonare con noi!</p>
//         <p className="flex text-center mt-6 ">
//           Le prove della NUOVA ORCHESTRA DI MILANO sono tutti i mercoledì sera
//           presso la parrocchia di S. Luigi Gonzaga a Milano, via Don Bosco 10
//         </p>
//         <p className="flex flex-col text-center mt-6 ">
//           {" "}
//           Per informazioni:
//           <a href="mailto: milarte.mi@gmail.com" className="text-red-600 underline">
//             milarte.mi@gmail.com
//           </a>
//           <a
//             href="mailto: milarte.mi@pec.it"
//             className="text-red-600 underline"
//           >
//             {" "}
//             milarte.mi@pec.it
//           </a>
//           <a
//             className="text-red-600 underline"
//             href="https://www.giuseppedinardo.it/"
//           >
//             Giuseppe Dinardo:
//           </a>
//           <a className="text-red-600 underline" href="tel:+39 338 830 3778">
//             +39 338 830 3778
//           </a>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default SuonaConNoi;
import React from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { GiViolin } from "react-icons/gi";
import { GiMusicalScore } from "react-icons/gi";
const SuonaConNoi = () => {
  return (
    <section
      id="suona-con-noi"
      className="relative flex flex-col items-center justify-center pb-20 bg-gradient-to-br from-white via-amber-50 to-amber-100 overflow-hidden"
    >
      {/* Icona decorativa */}
      <GiViolin className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      <h2 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        SUONA CON NOI
      </h2>
      {/* Contenuto */}
      <div className="mt-5 relative z-10 w-11/12 md:w-2/3 lg:w-1/2 bg-white/60 backdrop-blur-md rounded-3xl shadow-md border border-amber-100 px-6 py-10 text-center">
        <p className="mt-6 text-lg md:text-xl text-amber-900 leading-relaxed">
          Vieni a far parte della <strong>Nuova Orchestra di Milano</strong>!
        </p>

        <p className="mt-4 text-base md:text-lg text-amber-800 leading-relaxed">
          Le prove si tengono ogni{" "}
          <span className="font-semibold">mercoledì sera</span> presso la{" "}
          <strong>Parrocchia di S. Luigi Gonzaga</strong> a Milano,
          <br />
          <span className="inline-flex items-center justify-center mt-1">
            <FaMapMarkerAlt className="mr-2 text-red-600" />
            Via Don Bosco 10
          </span>
        </p>

        {/* Contatti */}
        <div className="mt-8 flex flex-col items-center space-y-3 text-base md:text-lg">
          <p className="font-medium text-amber-900">Per informazioni:</p>

          <a
            href="mailto:milarte.mi@gmail.com"
            className="flex items-center gap-2 text-red-700 hover:text-red-500 underline-offset-4 hover:underline transition"
          >
            <FaEnvelope /> milarte.mi@gmail.com
          </a>

          <a
            href="mailto:milarte.mi@pec.it"
            className="flex items-center gap-2 text-red-700 hover:text-red-500 underline-offset-4 hover:underline transition"
          >
            <FaEnvelope /> milarte.mi@pec.it
          </a>

          <a
            href="https://www.giuseppedinardo.it/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-red-700 hover:text-red-500 underline-offset-4 hover:underline transition"
          >
            <GiMusicalScore />
            Giuseppe Dinardo
          </a>

          <a
            href="tel:+393388303778"
            className="flex items-center gap-2 text-red-700 hover:text-red-500 underline-offset-4 hover:underline transition"
          >
            <FaPhoneAlt /> +39 338 830 3778
          </a>
        </div>
      </div>
    </section>
  );
};

export default SuonaConNoi;
